import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import ScrollToTop from "../ScrollToTop";
import ScrollToTopButton from "../ScrollToTopButton/ScrollToTopButton";

const Layout = () => {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      {/* Yahan page render hoga */}
      <Outlet />

      <ScrollToTopButton />
      <Footer />
    </>
  );
};

export default Layout;